import SlideMenu from './SlideMenu';

export default SlideMenu;
